import React from 'react';
import PropTypes from 'prop-types';
import FlipMove from 'react-flip-move';
import { Menu, Divider } from 'semantic-ui-react';
import { LeftNav, ResourceSearch, RightNav, ClientHome, Resource } from '../containers/index';
import { resourceType } from '../types';
import './styles/App.css';
import './styles/ClientApp.css';

const propTypes = {
  view: PropTypes.string.isRequired,
  searchResultResources: PropTypes.arrayOf(resourceType).isRequired,
};

const ClientApp = ({ view, searchResultResources }) => (
  <div className="appContainer">
    <Menu id="mainNav" fixed="top">
      <LeftNav />
      <ResourceSearch />
      <RightNav />
    </Menu>
    {
      (view === 'home') ? (
        <ClientHome search={() => this.search} />
      ) : (
        <div id="resource-table">
          {/*
          <FlipMove
            duration={400}
            easing="ease"
            staggerDurationBy={0}
            staggerDelayBy={0}
            typeName={null}
          >
          */}
          {[
            ...(searchResultResources ?
              searchResultResources.filter(r => r.done).map((resource, index) => (
                <Resource
                  resource={resource}
                  index={index}
                  key={resource._id}
                  clientMode
                />
              )) : null),
            <a href="http://www.bu.edu/globalprograms/hub/share-a-resource/" target="_blank" rel="noopener noreferrer">
              <img id="add-resource" src="http://www.bu.edu/globalprograms/wp-assets/media/compass/img/add-card.png" alt="Add a resource" />
            </a>,
          ]}
          {/* </FlipMove> */}
          <div style={{ width: '100%', padding: '0 17px' }}>
            <Divider clearing />
          </div>
          <p style={{ margin: '0 0 1em' }}>Still have questions? Contact Global Programs
            (<a href="mailto:global@bu.edu">global@bu.edu</a>).</p>
        </div>
      )
    }
  </div>
);

ClientApp.propTypes = propTypes;

export default ClientApp;



// WEBPACK FOOTER //
// ./src/components/ClientApp.jsx